const CookieStorage = {
    // Set a cookie
    set: (name, value, options = {}) => {
      let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  
      if (options.days) {
        const date = new Date();
        date.setTime(date.getTime() + options.days * 24 * 60 * 60 * 1000);
        cookieStr += `; expires=${date.toUTCString()}`;
      } else if (options.maxAge) {
        cookieStr += `; max-age=${options.maxAge}`;
      }
  
      if (options.path) cookieStr += `; path=${options.path}`;
      if (options.secure) cookieStr += `; secure`;
      if (options.sameSite) cookieStr += `; samesite=${options.sameSite}`;
  
      document.cookie = cookieStr;
    },
  
    // Get a cookie
    get: (name) => {
      const cookies = document.cookie.split('; ').map(c => c.split('='));
      const cookie = cookies.find(([key]) => key === decodeURIComponent(name));
      return cookie ? decodeURIComponent(cookie[1]) : null;
    },
  
    // Remove a cookie
    remove: (name, path = '/') => {
      document.cookie = `${encodeURIComponent(name)}=; path=${path}; max-age=0`;
    },
  
    // Check if cookie exists
    has: (name) => {
      return CookieStorage.get(name) !== null;
    }
  };
  
  export default CookieStorage;
  
  